var h = Object.defineProperty;
var a = (c, e, t) => e in c ? h(c, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : c[e] = t;
var s = (c, e, t) => a(c, typeof e != "symbol" ? e + "" : e, t);
import { clsx as r } from "clsx";
import { twMerge as n } from "tailwind-merge";
function l(...c) {
  return n(r(c));
}
class m {
  constructor(e = 100) {
    s(this, "cache", /* @__PURE__ */ new Map());
    s(this, "maxSize");
    this.maxSize = e;
  }
  get(e) {
    const t = this.cache.get(e);
    return t !== void 0 && (this.cache.delete(e), this.cache.set(e, t)), t;
  }
  set(e, t) {
    if (this.cache.has(e))
      this.cache.delete(e);
    else if (this.cache.size >= this.maxSize) {
      const i = this.cache.keys().next().value;
      i !== void 0 && this.cache.delete(i);
    }
    this.cache.set(e, t);
  }
  has(e) {
    return this.cache.has(e);
  }
  get size() {
    return this.cache.size;
  }
}
export {
  m as LRUCache,
  l as cn
};
